
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/donation-form/[donationFormId]",
      function () {
        return require("private-next-pages/embed/donation-form/[donationFormId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/donation-form/[donationFormId]"])
      });
    }
  